<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="false" @updateSelect2="initSelect2"></app-sub-header>
      <!--end::Container-->
    </div>
    <!-- Loader -->
    <div class="container-xxl" v-show="!isReady">
      <Loader />
    </div>
    <!--begin::Post-->
    <div v-show="isReady">
      <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
          <div class="card">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
              <div class="card-title">
                <h3 class="card-label">{{ $t('review.list') }}</h3>
              </div>
              <div class="card-toolbar">
                <Select2
                    v-model="query.status"
                    :isRequired="false"
                    :multiple="false"
                    :show-search="false"
                    :placeholderText="$t('e-commerce.checkout.status')"
                    :selectClass="'form-select form-select-solid kt_select2 w-200px'"
                    containerClass="d-flex flex-column fv-row me-5 mw-500px"
                    name="review_status"
                >
                  <option v-for="(status, index) in reviewStatus" :key="index" :value="status.value">{{ status[locale] }}</option>
                </Select2>


              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_review">
                  <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-100px">{{ $t('review.star')}}</th>
                    <th class="min-w-100px">{{ $t('review.customer')}}</th>
                    <th class="min-w-100px">{{ $t('review.comment')}}</th>
                    <th class="min-w-100px">{{ $t('review.date')}}</th>
                    <th class="min-w-100px">{{ $t('review.status')}}</th>
                    <th class="min-w-100px">{{ $t('review.product')}}</th>
                    <th class="min-w-100px">{{ $t('action') }}</th>
                  </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="editModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.detail') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>

          <div class="modal-body">
            <!--begin:Form-->

            <form id="kt_modal_new_target_form" class="form"  @submit.prevent="updateReviewData">
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.date')}}</span>
                </label>
                <!--end::Label-->
                <input type="text"  readonly class="form-control form-control-solid" v-model="editForm.created_at" required />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.customer')}}</span>
                </label>
                <!--end::Label-->
                <input type="text"  readonly class="form-control form-control-solid" v-model="editForm.customer"  required />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.product')}}</span>
                </label>
                <!--end::Label-->
                <input type="text"  readonly  class="form-control form-control-solid" v-model="editForm.product"  required />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.star')}}</span>
                </label>

                <div class="d-flex align-items-center">
                  <span v-html="renderStars(editForm.rating)"></span>
                </div>
              </div>

              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="">{{$t('review.comment')}}</span>
                </label>
                <!--end::Label-->
                <textarea readonly  class="form-control form-control-solid" v-model="editForm.comment"   rows="8" ></textarea>
              </div>
              

              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>

              </div>
            </form>
            <!--end:Form-->
          </div>


        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" id="editStatusModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.edit_status') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>

          <div class="modal-body">
            <!--begin:Form-->
            <form id="kt_modal_new_target_form" class="form"  @submit.prevent="updateReviewData">

              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{ $t('review.status') }}</span>
                </label>
                <select
                    class="form-select form-select-solid kt_select2"
                    data-control="select2"
                    name="status"
                    v-model="editForm.status"
                    :data-placeholder="$t('review.status')"
                    data-allow-clear="true">
                  <option></option>
                  <option  v-for="(status, index) in getReviewsStatus" :key="index"
                           :value="status.value">{{ status[locale] }} </option>
                </select>
              </div>

              <div class="modal-footer">
                <button type="submit" id="kt_submit_create_code_psromo" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{  $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
                <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>

              </div>
            </form>
            <!--end:Form-->
          </div>


        </div>
      </div>
    </div>

  </div>
</template>

<script setup>

import AppSubHeader from "@/views/E-commerce/Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import { BASE_URL, BASE_IMAGE_URL } from "@/services/api";
import {useStore} from "vuex";
import {computed, nextTick, onMounted, reactive, ref, watch} from "vue";
import { useRouter, useRoute } from "vue-router"
import {useHasAbility} from "@/composables/hasAbility";
import Ls from "@/services/ls";
import Select2 from "@/components/Select2.vue";

import InputDate from "@/components/InputDate.vue";
import i18n from "@/plugins/i18n";


const router = useRouter()
const store = useStore()
const { can } = useHasAbility()

const locale = computed(() => i18n.global.locale)
const getDatatableLocaleUrl = computed(() => {
  return locale.value === 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json"
})
const getReviewsStatus = computed(() => store.getters['ecommerce/getReviewStatus'])

const title = ref("navigation.e-commerce")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.store.dashboard',
    path: '/admin/dashboard'
  },
  {
    name: 'breadcrumbs.review.list',
    path: '/admin/ecommerce/reviews'
  }
])
const isReady = ref(false)
const table = ref()
const formDeleteData = ref({
  id: null,
  row: null
})
const formCreateData = ref({
  title: '',
  image: '/assets/media/img_default.png',
  apply: ""
})
const image = ref("")
const processCreating = ref(false)
const editForm = ref({
  id: '',
  customer: '',
  product: '',
  comment: '',
  ceated_at: '',
  status: '',
  rating: '',
})
const query = ref({
  status: 'all'
})
const isLoading = ref(false)
const reviewStatus = computed(() => store.getters['ecommerce/getReviewStatus'])

watch(
    () => [
      query.value.status,
      ],
    () => {
      const url = BASE_URL + `/get/rating/product/datatable?status=${query.value.status}`
      table.value.ajax.url(url).load()

    })


watch(() => locale.value, () => {
  nextTick(() => {
    fetchDatas()
  })
})
onMounted(() => {
  isReady.value = false
  initSelect2()
  store.dispatch('ecommerce/loadReviewStatus')
  fetchDatas()
  store.dispatch('ecommerce/loadReviewStatus')
    query.value.status = 'all'
  isReady.value = true
})

function displayApplyName(value) {
  let apply = getReviewsStatus.value.find(ap => ap.value === value)
  let name=''
  let className=''
  if(apply){
    name = apply[locale.value];
    className = apply.className
  }
  return { name, className }
}

function initSelect2() {
  KTApp.initSelect2()
  $(".kt_select2").select2()

  $(".kt_select2").change((e) => {
    switch (e.target.name) {
      case 'status':
        editForm.value.status = e.target.value
        break;
        case 'review_status':
        query.value.status = e.target.value
        break;
      default:
        break;
    }
  });

}
// Les textes viennent des clients (commentaire, nom) : toujours échappés avant d'être
// injectés dans le HTML du tableau ou dans un attribut data-*.
function esc(value) {
  return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
}

function fetchDatas() {
  const AUTH_TOKEN = Ls.get('auth.token')
  table.value = $("#kt_datatable_review").DataTable({
    destroy: true,
    responsive: !0,
    searchDelay: 500,
    processing: !0,
    serverSide: !0,
    pageLength: Ls.get('pageLength') ?? 10,
    lengthMenu: [5, 10, 25, 50, 75, 100 ],
    order: [[ 1, 'asc']],
    ajax: {
      url:  BASE_URL +`/get/rating/product/datatable?status=${query.value.status}`,

      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      }
    },
    columns: [
      { data: "rating" },
      { data: "customer" },
      { data: "comment" },
      { data: "created_at" },
      { data: "status" },
      { data: "product" },
      { data: "Actions", responsivePriority: -1 }
    ],
    columnDefs: [
      {
        targets: -7, // colonne rating
        className: "dt-center",
        render: (rating, a, e) => {
          const fullStars = parseInt(rating);
          const emptyStars = 5 - fullStars;

          let starsHtml = '';

          for (let i = 0; i < fullStars; i++) {
            starsHtml += '<i class="fas fa-star" style="color:#FFD700;"></i>';
          }
          for (let i = 0; i < emptyStars; i++) {
            starsHtml += '<i class="far fa-star" style="color:#989595;"></i>';
          }

          // Mobile : les autres colonnes sont repliées par DataTables, on résume donc
          // l'avis ici (client, produit, date, statut, commentaire). Masqué dès 768px.
          const apply = displayApplyName(e.status)
          return `
      <div class="d-flex justify-content-start justify-content-md-center" style="gap:2px;">
        ${starsHtml}
      </div>
      <div class="d-md-none text-start mt-2" style="white-space:normal;">
        <div class="fw-bolder text-gray-800 fs-6">${esc(e.customer)}</div>
        <div class="text-muted fs-7">${esc(e.product)} · ${esc(e.created_at)}</div>
        <div class="fs-7 fw-bold ${apply.className || ''}">${esc(apply.name)}</div>
        <div class="text-gray-700 fs-7 mt-1" style="word-break:break-word;">${esc(e.comment)}</div>
      </div>
    `;
        }
      },


      {
        targets: -6,
        className: "dt-center clickable" ,
        render:  (t, a, e, l) => {
          return '<span data-id="'+ e.id +'">' + esc(t) + "</span>";
        },
      },
      {
        targets: -5,
        className: "dt-center clickable" ,
        render:  (t, a, e, l) => {
          return '<span data-id="'+ e.id +'">' + esc(t) + "</span>";
        },
      },

      {
        targets: -4,
        className: "dt-center clickable" ,
        render:  (t, a, e, l) => {
          return '<span data-id="'+ e.id +'">' + esc(t) + "</span>";
        },
      },

      {
        targets: -3,
        className: "dt-center clickable text-center" ,
        render: function (t, a, e, l) {
          const apply = displayApplyName(t)
          return '<span data-id="'+ e.id +'" class="'+ apply.className +'">' + apply.name + "</span>";
        },
      },

      {
        targets: -2,
        className: "dt-center clickable" ,
        render:  (t, a, e, l) => {
          return '<span data-id="'+ e.id +'">' + esc(t) + "</span>";
        },
      },


      {
        width: "20%",
        targets: -1,
        "className": "dt-center",
        title: "Actions",
        orderable: !1,
        render: (t, a, e, l) => {
          let render=""

          render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}"  data-row="${l.row}" data-id="${e.id}" data-customer="${esc(e.customer)}" data-product="${esc(e.product)}" data-comment="${esc(e.comment)}" data-rating="${e.rating}"  data-status="${e.status}"  data-date="${e.created_at}" class="btn btn-sm btn-clean btn-icon edit_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}"  data-row="${l.row}" data-id="${e.id}" data-customer="${esc(e.customer)}" data-product="${esc(e.product)}" data-comment="${esc(e.comment)}" data-rating="${e.rating}"  data-status="${e.status}"  data-date="${e.created_at}" class="la la-eye fs-2"></i></a>`

          render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}"  data-row="${l.row}" data-id="${e.id}" data-customer="${esc(e.customer)}" data-product="${esc(e.product)}" data-comment="${esc(e.comment)}"  data-status="${e.status}"  data-date="${e.created_at}" class="btn btn-sm btn-clean btn-icon edit_status_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}"  data-row="${l.row}" data-id="${e.id}" data-customer="${esc(e.customer)}" data-product="${esc(e.product)}" data-comment="${esc(e.comment)}"  data-status="${e.status}"  data-date="${e.created_at}" class="la la-edit fs-2"></i></a>`


          return render
        },
      },
    ],
    language: {
      url: getDatatableLocaleUrl.value,
    }
  });

  $(document).on("click", "#kt_datatable_review .btn_change_online", (e) => {
    const id = e.target.getAttribute('data-id');
    const isChecked = e.target.checked;

    updateReviewStatus(id, isChecked);  });

  $(document).on("click", "#kt_datatable_review .edit_btn", (e) => {

    editForm.value = {
      id : e.target.getAttribute('data-id'),
      customer: e.target.getAttribute('data-customer'),
      product: e.target.getAttribute('data-product'),
      comment: e.target.getAttribute('data-comment'),
      created_at: e.target.getAttribute('data-date'),
      status: e.target.getAttribute('data-status'),
      rating: e.target.getAttribute('data-rating')
    }
    nextTick(() =>  initSelect2())
    $('#editModal').modal('toggle')
  });
  $(document).on("click", "#kt_datatable_review .edit_status_btn", (e) => {

    editForm.value = {
      id : e.target.getAttribute('data-id'),
      customer: e.target.getAttribute('data-customer'),
      product: e.target.getAttribute('data-product'),
      comment: e.target.getAttribute('data-comment'),
      created_at: e.target.getAttribute('data-date'),
      status: e.target.getAttribute('data-status'),
      rating: e.target.getAttribute('data-rating')
    }
    nextTick(() =>  initSelect2())
    $('#editStatusModal').modal('toggle')
  });

  $(document).on("click", "#kt_datatable_review .delete_btn", (e) => {
    formDeleteData.value.id = e.target.getAttribute('data-id')
    const id = e.target.getAttribute('data-id')
    formDeleteData.value.row = e.target.getAttribute('data-row')
    deleteReview(id)
  });
}

function toggleCreateModal() {
  formCreateData.value = {
    title: '',
    image: '',
    apply: ""
  }
  KTImageInput.init();
  $('#createModal').modal('toggle')
}

async function deleteReview(id) {
  Swal.fire({
    title: i18n.global.t('swal.review_deleting'),
    text: i18n.global.t('swal.text'),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: i18n.global.t('swal.yes'),
    cancelButtonText: i18n.global.t('swal.no'),
  }).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('review/deleteReview', id)
        table.value.ajax.reload()
        window.toastr['success'](i18n.global.t('notification.review.delete_success'))
      }catch (e) {
      }
    }
  });
}


async function updateReviewStatus(id, isChecked) {
  try {
    const isSuccess = await store.dispatch('review/updateReviewStatus', { id, isChecked });

    if (isSuccess) {
      if (isChecked) {
        window.toastr['success'](i18n.global.t('notification.review.status_success_true'));
      } else {
        window.toastr['success'](i18n.global.t('notification.review.status_success_false'));
      }
    }
  } catch (e) {
    window.toastr['error'](i18n.global.t('notification.review.update_status_error'));
  }
}


async function updateReviewData() {
  const id = editForm.value.id
  const status = editForm.value.status
  try {
    await store.dispatch('review/updateReviewStatus', {id, status} );

    if (status === 'PUBLISHED') {
      window.toastr['success'](i18n.global.t('notification.review.status_success_true'));
    } else if (status === 'OFFLINE') {
      window.toastr['success'](i18n.global.t('notification.review.status_success_false'));
    } else {
      window.toastr['success'](i18n.global.t('notification.review.status_success_archive'));
    }

    table.value.ajax.reload()
    $('#editStatusModal').modal('toggle')
  }catch (e) {
    window.toastr['error'](i18n.global.t('notification.review.update_status_error'));
  }
}
function renderStars(rating) {
  const fullStars = parseInt(rating);
  const emptyStars = 5 - fullStars;

  let html = '';

  for (let i = 0; i < fullStars; i++) {
    html += '<i class="fas fa-star" style="color:#FFD700; font-size:18px;"></i>';
  }
  for (let i = 0; i < emptyStars; i++) {
    html += '<i class="far fa-star" style="color:#989595; font-size:18px;"></i>';
  }

  return html;
}

</script>

<style scoped>

</style>